<template>
  <div>
    <logged-in-header />
    <products-panel />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import productsPanel from "../components/pending-external-products/PendingExternalProductsPanel";

export default {
  components: {
    loggedInHeader,
    productsPanel
  }
};
</script>
